import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { LabelingContainer } from '~/components/elements/LabelingContainer'
import {
  StyledTextArea,
  type StyledTextAreaProps,
} from '~/components/elements/StyledTextArea'
import { useFormField } from '~/hooks/useFormField'
import { useLogEvent } from '~/hooks/useLogEvent'

import { type InputValues } from '../utils'

export type WhatInputProps = {
  className?: string
  index: number
}

export const WhatInput = ({ className, index }: WhatInputProps) => {
  const { control } = useFormContext<InputValues>()
  const whatField = useFormField(control, `strategies.${index}.what`)
  const { t } = useTranslation()

  const logEvent = useLogEvent()
  const handleBlur = React.useCallback<
    EH<StyledTextAreaProps, 'onBlur'>
  >(() => {
    whatField.onBlur()
    logEvent('Edit WHAT')
  }, [logEvent, whatField])

  return (
    <LabelingContainer className={className} label={t('what')}>
      <StyledTextArea
        autoSize={true}
        rows={1}
        width="100%"
        {...whatField}
        onBlur={handleBlur}
      />
    </LabelingContainer>
  )
}
